export default {
  setEnabledFinancialModules (state, modules) {
    state.enabledFinancialModules.modules = modules || []
    state.enabledFinancialModules.loaded = true
  }
}
